/// <amd-module name="Core/Medius.Core.Web/Scripts/shared/prepaymentType"/>

export const prepaymentType = "Medius.Apa.Persistence.PrepaymentInvoice.PrepaymentSupplierInvoice";